import useModal from '@/hooks/useModal'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectWhatsNewData } from '@/store/slices/modal/selector'
import WhatsNewSingleColumn from './WhatsNewSingleColumn'
import WhatsNewTwoColumn from './WhatsNewTwoColumn'
import api from '@/services/api'
import { useAppDispatch } from '@/store/store'
import { setWhatsNewData } from '@/store/slices/modal/action'

export const WHATS_NEW_SINGLE_COLUMN_BY_DEEPLINK = "inside"

function ModalWhatNew({ onClosed = () => {} }) {
  const { setShowModalType } = useModal()
  const dispatch = useAppDispatch()
  const data = useSelector(selectWhatsNewData)

  useEffect(() => {
    if (data?.length) return

    let isMounted = true

    const getWhatsNew = async () => {
      const dataWhatNew = await api.getWhatsNew().catch(() => null)
      if (!isMounted) return

      const latestItem = dataWhatNew?.objects?.[0]
      if (latestItem) {
        dispatch(setWhatsNewData([latestItem]))
      } else {
        setShowModalType(null)
      }
    }

    getWhatsNew()

    return () => {
      isMounted = false
    }
  }, [data, dispatch, setShowModalType])

  if (!data || !data.length) return null

  const onClose = () => {
    onClosed()
    setShowModalType(null)
  }

  if (data[0]?.deeplink.toLowerCase() === WHATS_NEW_SINGLE_COLUMN_BY_DEEPLINK.toLowerCase()) {
    return <WhatsNewSingleColumn data={data} onClose={onClose} />
  }

  return <WhatsNewTwoColumn data={data} onClose={onClose} />
}

export default ModalWhatNew
